import { types } from 'mobx-state-tree';
import { v4 as uuid } from 'uuid';

import { partiallyUpdateModel, Event } from '../definitions/Common';
import Application from './Application';


const InsMotoDocument = types
    .model('InsMotoDocument', {
        id: types.optional(types.identifier, () => uuid()),
        schemaVersion: 3,
        application: types.optional(Application, {}),

        events: types.array(Event),
    })
    .actions(self => ({
        trackEvent({ type, details, metadata }) {
            if (!type) {
                throw new Error('Must specify an event type');
            }

            self.events.push({
                type,
                details,
                metadata,
            });
        },
        update(values) {
            partiallyUpdateModel(self, values);
        },

        // This setter is used to set the application province state. The province
        // is used for routing and question determination. setting the province
        // here will override the address field from its previous state to ensure
        // we aren't created an invalid address
        setApplicationProvince(province) {
            self.application.applicant = {
                ...self.application.applicant,
                address: {
                    province,
                },
            };
        },
    }));

export default InsMotoDocument;
